export const initLightModeObserver = () => {
   const updateImages = () => {
      const isLightMode = document.body.hasAttribute('data-lightmode');
      document.querySelectorAll('img[data-lightmodeimg]').forEach(img => {
         const currentSrc = img.getAttribute('src');
         // Guardar src original solo si no existe
         if (!img.hasAttribute('data-originalsrc')) {
            img.setAttribute('data-originalsrc', currentSrc);
         }
         if (isLightMode) {
            const originalSrc = img.getAttribute('data-originalsrc');
            const path = originalSrc.substring(0, originalSrc.lastIndexOf('/') + 1);
            const filename = originalSrc.substring(originalSrc.lastIndexOf('/') + 1);
            // Verificar si ya tiene el prefijo lm_
            if (!filename.startsWith('lm_')) {
               img.setAttribute('src', path + 'lm_' + filename);
            }
         } else {
            // Restaurar siempre desde el original guardado
            const originalSrc = img.getAttribute('data-originalsrc');
            if (originalSrc) {
               img.setAttribute('src', originalSrc);
            }
         }
      });
   };
   // Observer para cambios en el DOM (nuevas imágenes)
   const domObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
         if (mutation.type === 'childList') {
            updateImages();
         }
      });
   });
   // Observer para cambios en data-lightmode
   const lightModeObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
         if (mutation.attributeName === 'data-lightmode') {
            updateImages();
         }
      });
   });
   // Iniciar observers
   domObserver.observe(document.body, {
      childList: true,
      subtree: true
   });
   lightModeObserver.observe(document.body, {
      attributes: true
   });
   // Ejecutar primera vez
   updateImages();
   // Retornar función de limpieza
   return () => {
      domObserver.disconnect();
      lightModeObserver.disconnect();
   };
};